var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('model',{attrs:{"dialogVisible":_vm.dialogVisible,"width":"80%","title":"预警信息"},on:{"close":_vm.close}},[_c('div',{staticClass:"container"},[_c('dv-scroll-board',{staticStyle:{"width":"18.65rem","height":"7rem"},attrs:{"config":_vm.config},on:{"mouseover":_vm.mouseover}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }